import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-home-clock',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './home-clock.component.html',
  styleUrl: './home-clock.component.scss',
})
export class HomeClockComponent {
  time: Date = new Date();
  intervalId: any;

  ngOnInit() {
    this.intervalId = setInterval(() => {
      this.time = new Date();
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }
}
